import React from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import {
  List, ListSubheader,
} from '@mui/material';
import Field from './field';
import itemTypes from '../itemTypes';

function AvailableFieldList({
  onClick,
  activeField,
  label,
  onDblClick,
  onDragEnd,
  visibleColumns,
  setOpenedColumns,
  openedColumns,
}) {
  // eslint-disable-next-line no-unused-vars
  const [_collected, ref] = useDrop({
    accept: [
      itemTypes.group, itemTypes.selection, itemTypes.order, itemTypes.filter, itemTypes.column,
    ],
    drop: (item) => onDragEnd(item),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
      // CanDrop: monitor.canDrop(),
      didDrop: monitor.didDrop(),
    }),
  });

  return (
    <List
      sx={{
        border: 1, borderColor: 'divider', borderRadius: 2, overflow: 'auto', flex: '1 1 auto', width: 50,
      }}
      ref={ref}
      component="nav"
      subheader={(
        <ListSubheader component="div" sx={{ bgcolor: 'grey.100' }}>
          {label}
        </ListSubheader>
      )}
      dense
      disablePadding
    >
      {visibleColumns && visibleColumns.map((f) => (
        <Field
          key={f.name}
          label={f.label}
          name={f.name}
          onClick={onClick}
          active={activeField === f.name}
          onDblClick={onDblClick}
          level={f.lvl}
          onToggleOpen={setOpenedColumns}
          hasChild={f.hasChild}
          opened={openedColumns.includes(f.name)}
        />
      ))}
    </List>
  );
}

export const availablePropType = PropTypes.arrayOf(PropTypes.shape({
  name: PropTypes.string,
  label: PropTypes.string,
}));

AvailableFieldList.propTypes = {
  onClick: PropTypes.func.isRequired,
  activeField: PropTypes.string,
  label: PropTypes.string.isRequired,
  onDblClick: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  visibleColumns: availablePropType,
  setOpenedColumns: PropTypes.func.isRequired,
  openedColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
};

AvailableFieldList.defaultProps = {
  activeField: null,
  visibleColumns: [],
};
export default AvailableFieldList;
